import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import styles from './Spin.module.scss';
// import { Spin as SpinAnt } from 'antd';

export interface SpinProps {}

const Spin: React.FC<SpinProps> = () => {
  //props: SpinProps
  // return <SpinAnt size="small" />;
  return (
    <div className={styles.container}>
      <LoadingOutlined />
    </div>
  );
};

export default Spin;
